<!-- components\newhome\ofertas-destacadas\OfertasDestacadasGrid.vue -->
<template>
  <div v-if="ofertas.length >= 1" class="bg-GRIS_CLARO flex flex-col w-full gap-6 md:gap-10 my-10 items-center px-2 md:px-0 py-4 md:py-4">
    <h2 class="text-center md:text-2xl text-lg font-bold">Promociones Destacadas</h2>

    <!-- Desktop: Carrusel con 3 items -->
    <div class="hidden md:block max-w-[76rem] w-full px-4">
      <Carrusel 
        :data="ofertas"
        :itemsPorPagina="3"
        ClaseSlide="w-full h-[34rem] flex gap-5 justify-center pb-2"
        :autoplay="true"
        :autoplayInterval="6000"
        :bucle="true"
        
        :habilitarBotonesNav="true"
        customBotonesNavClass="p-2 bg-white hover:bg-ROJO_LEON text-GRIS_LEON hover:text-white border-2 border-GRIS_CLARO_COMPLEMENTARIO_2"
        customIconClass="text-current w-5 h-5"
        customPrevPosition="left-2"
        customNextPosition="right-2"
        
        :motrarPuntos="true"
        PadreDotClass="pt-2 flex justify-center"
        customDotClass="w-3 h-3"
        customActiveDotClass="bg-ROJO_LEON w-6"
        customInactiveDotClass="bg-GRIS_CLARO_COMPLEMENTARIO_2">
        
        <template #contenido="{ items }">
          <CardTipo5 
            v-for="(listado, index) in items" 
            :key="listado.id"
            :oferta="listado"
          />
        </template>
      </Carrusel>
    </div>

    <!-- Mobile: Carrusel con 1 item -->
    <div class="block md:hidden w-full">
      <Carrusel 
        :data="ofertas"
        :itemsPorPagina="1"
        ClaseSlide="w-full h-[34rem] flex justify-center px-2 pb-2"
        :autoplay="true"
        :autoplayInterval="5000"
        :bucle="true"
        
        :habilitarBotonesNav="false"
        customBotonesNavClass="p-2 bg-white hover:bg-ROJO_LEON text-GRIS_LEON hover:text-white border-2 border-GRIS_CLARO_COMPLEMENTARIO_2"
        customIconClass="text-current w-4 h-4"
        customPrevPosition="left-2"
        customNextPosition="right-2"
        
        :motrarPuntos="true"
        PadreDotClass="pt-2 flex justify-center"
        customDotClass="w-2 h-2"
        customActiveDotClass="bg-ROJO_LEON w-6"
        customInactiveDotClass="bg-GRIS_CLARO_COMPLEMENTARIO_2">
        
        <template #contenido="{ items }">
          <CardTipo5 
            v-for="(oferta, index) in items" 
            :key="oferta.id"
            :oferta="oferta"
          />
        </template>
      </Carrusel>
    </div>

    <BotonTipo1 
      texto="Ver todas las promociones"
      button-classes="border py-2 px-4 rounded-lg font-semibold flex mx-auto gap-2 items-center justify-center bg-ROJO_LEON text-white border-ROJO_LEON hover:bg-white hover:text-ROJO_LEON hover:border-ROJO_LEON transition-all duration-200"
      :svg-tipo="1"
      @click="manejarClick"
    />
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import BotonTipo1 from '~/components/Botones/BotonTipo1.vue';
import CardTipo5 from '~/components/Cards/CardTipo5.vue';
import Carrusel from '~/components/Carruseles/Carrusel.vue';

const ofertas = ref([]);
const loading = ref(true);

const manejarClick = () => {
  globalThis.location.href = '/concursos-promociones'
}

onMounted(async () => {
  try {
    const response = await $fetch('/api/concursos-promociones', {
      query: {
        action: 'getConcursosPromocionesHome'
      }
    });

    if (response.status === 'success') {
      ofertas.value = response.data;
      console.log(ofertas.value);
    } else {
      console.error('Error en la respuesta:', response.message);
    }
  } catch (error) {
    console.error('Error al obtener las ofertas:', error);
  } finally {
    loading.value = false;
  }
});
</script>